import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setErrorCode', function setErrorCode(response: Response) {
    store.deleteErrorCode = (response as unknown) as string;
});
